var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

$(document).ready(() => {
  $(".slider").slick({
    centerMode: true,
    infinite: true,
    arrows: false,
    dots: true,
    lazyLoad: "ondemand",
    focusOnSelect: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });
});
